import { BrowserRouter, Switch } from 'react-router-dom';
import loadable                  from '@loadable/component';
import React                     from 'react';
import PublicRoute               from './PublicRoute';
import PrivateRoute              from './PrivateRoute';

/// REPORTS
import Splash     from '../Components/Splash';
import Login      from '../Components/Login';
import Onboarding from '../Components/Onboarding';

import { Consumer } from '../store';

/* Components */
const Register      = loadable(() => import('../Components/Register'));

export default () => (
  <Consumer>
    {({ language }) => (
      <BrowserRouter>
        <Switch>
          <PublicRoute exact path={'/'}                                               component={Splash} />
          <PublicRoute exact path={'/login'}                                          component={Login} />
          <PublicRoute exact path={'/proceso-registro/:typeView'}                     component={Onboarding} />
          <PublicRoute exact path={'/onboarding/:view/:keyAct/:primaryKey/:tarjet'}   component={Register} />
        </Switch>
      </BrowserRouter>
    )}
  </Consumer>
)
